import instance from "../utils/network";
import { PaymentMethod } from "./settlement";

export interface PointSendRequest {
  memberId: number;
  pointAmount: number;
  memo: string;
  pubId: number;
}

export interface PayDepositRequest {
  memberId: number;
  pubId: number;
  point: number;
  memo: string;
  payments: PayMemberDepositPaymentRequest[];
}

export interface PayMemberDepositPaymentRequest {
  amount: number;
  paymentMethod: PaymentMethod;
}

export interface MemberTransactionLogResponse {
  total: number;
  list: PointTransaction[];
}

export interface PointTransaction {
  id: number;
  memberId: number;
  pointAmount: number; // 양수: 획득, 음수: 차감
  memo: string;
  pubId: number;
  settledAt: string;
  isRefund: boolean;
  createdAt: string;
}

export function getMemberTransactionPointLogs(
  memberId: number,
  page: number,
  limit: number,
): Promise<MemberTransactionLogResponse> {
  return instance.get(`/seller/pub-point/member/logs`, {
    params: { memberId, page, limit },
  });
}

export function pointSend(
  data: PointSendRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/pub-point/member`, data);
}

export function pointRefund(
  transactionId: number,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/pub-point/member/refund/${transactionId}`);
}

export function depositPay(
  request: PayDepositRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/pub-point/deposit/pay`, request);
}

export function depositRefund(
  depositLogId: number,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/pub-point/deposit/refund/${depositLogId}`);
}
